module.exports = __webpack_public_path__ + "static/img/parking_equipment1_5.cf432f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/parking_equipment1_5.jpg
// module id = VcvP
// module chunks = 0